import { OtpInput } from './OtpInput'
import { authTexts } from '../auth.texts'

interface OtpVerificationProps {
  email: string
  code: string
  onCodeChange: (code: string) => void
  onSubmit: () => void
  onResend: () => void
  onChangeEmail: () => void
  serverError: string | null
  isVerifying: boolean
  isResending: boolean
  cooldownSeconds: number
}

export const OtpVerification = ({
  email,
  code,
  onCodeChange,
  onSubmit,
  onResend,
  onChangeEmail,
  serverError,
  isVerifying,
  isResending,
  cooldownSeconds,
}: OtpVerificationProps) => {
  const texts = authTexts.otp
  const isComplete = code.length === 6
  const isDisabled = isVerifying || isResending
  const isCooldownActive = cooldownSeconds > 0

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (isComplete && !isVerifying) {
      onSubmit()
    }
  }

  const resendButtonText = isCooldownActive
    ? `${texts.resendCode} (${cooldownSeconds}s)`
    : texts.resendCode

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-foreground text-center">{texts.title}</h1>

      <p className="text-sm text-center text-foreground">
        {texts.description(email)}
        <br />
        {texts.hint}
      </p>

      <div className="flex flex-col gap-6 w-fit mx-auto">
        <OtpInput
          value={code}
          onChange={onCodeChange}
          hasError={!!serverError}
          disabled={isDisabled}
        />

        {serverError && (
          <p className="text-sm text-error-text text-center" role="alert">
            {serverError}
          </p>
        )}

        <button
          type="submit"
          disabled={!isComplete || isDisabled}
          className="w-full py-2.5 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary-hover disabled:bg-disabled disabled:text-disabled-foreground transition-colors cursor-pointer disabled:cursor-not-allowed"
        >
          {isVerifying ? texts.verifying : texts.validateButton}
        </button>
      </div>

      <div className="flex flex-col items-center gap-1">
        <button
          type="button"
          onClick={onResend}
          disabled={isDisabled || isCooldownActive}
          className="text-sm font-medium text-primary hover:text-primary-hover disabled:text-disabled-foreground transition-colors cursor-pointer disabled:cursor-not-allowed px-2 py-1"
        >
          {resendButtonText}
        </button>
        <button
          type="button"
          onClick={onChangeEmail}
          disabled={isDisabled}
          className="text-sm text-muted hover:text-foreground transition-colors cursor-pointer disabled:cursor-not-allowed px-2 py-1"
        >
          {texts.changeEmail}
        </button>
      </div>
    </form>
  )
}
